/* EVERY MANUAL THE PORTAL HAS, by key (Max 01/11: a Manual button on each module, in the portal's language).
   The four handbooks written for the portal carry Vietnamese, Korean, English and (since 01/11) Chinese in one file and
   pick their language from localStorage `hevnManualLang` (same origin as the portal), so opening one sets that first.
   The guides that were loose files are served by /api/manuals/<key>?lang= (backend manuals.js), which says on the page
   when it has to show another language. A module without a manual simply has no Manual button. */
export const MANUALS = {
  project: { src: '/api/development/manual', handbook: true },
  sample: { src: '/api/development/manual?part=sample', handbook: true },
  documents: { src: '/api/documents/manual', handbook: true },
  partner: { src: '/api/partner-samples/manual', handbook: true },
  'cash-entities': { src: '/api/manuals/cash-entities' },
  'cash-roles': { src: '/api/manuals/cash-roles' },
  ceo: { src: '/api/manuals/ceo' },
  gtm: { src: '/api/manuals/gtm' },
  driverlog: { src: '/api/manuals/driverlog' },
};

// the handbooks carry Chinese since 01/11 (a zh block after en); set false to have Chinese read English again
const HANDBOOK_ZH = true;

// French and Japanese since 04/11 (task #1173): a fr and a ja block in each handbook, a .fr / .ja file of each guide
const portalLang = (lang) => (['en', 'ko', 'vi', 'zh', 'fr', 'ja'].includes(lang) ? lang : 'en');

// The address to frame for `key` in the portal's language `lang`; null when there is no such manual.
export function manualSrc(key, lang) {
  const m = MANUALS[key];
  if (!m) return null;
  const l = portalLang(String(lang || '').slice(0, 2));
  if (m.handbook) {
    // the handbook has no language buttons of its own any more (Max 01/11): it reads this, and the lang= below makes
    // the frame reload when the portal's language changes
    try { localStorage.setItem('hevnManualLang', l === 'zh' && !HANDBOOK_ZH ? 'en' : l); } catch { /* the handbook falls back to the browser's language */ }
  }
  return `${m.src}${m.src.includes('?') ? '&' : '?'}lang=${l}`;
}

// The portal page that holds a manual on its own — what "Open in new tab" and a right-click open.
export const manualPage = (key) => `/manual/${encodeURIComponent(key)}`;
